import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';

export function AppLayout() {
  return (
    <div className="min-h-screen bg-bg">
      <Sidebar />
      <main className="p-5 pb-20 sm:p-6 md:ml-64 md:p-8 md:pb-8">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
